import Footer from './components/Footer'
import Technologies from './components/Technologies'
import Home from './components/Home'
import Mobile from './components/Mobile'
import Custom from './components/Custom'
import Website from './components/Website'
import Uservices from './components/Uservices'
import About from './components/About'
import Product from './components/Product'
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Chatbot from './components/Chatbot';
import SEO from './components/SEO';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Contact from './components/Contact';
import {Routes,Route, Outlet} from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <SEO />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={ <>
          <Navbar/>
            <Outlet />
            <Chatbot />
            <Footer/>
         
        </> } >
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/technologies" element={<Technologies/>} />
          <Route path="/mobile-app" element={<Mobile />} />
          <Route path="/custom" element={<Custom />} />
          <Route path="/website" element={<Website />} />
          <Route path="/ux-services" element={<Uservices />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Product />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
        </Route>
        
      </Routes>
    </div>
  );
}

export default App;
